// extracted by mini-css-extract-plugin
export var container = "_5g-0";
export var containerTopRight = "_5g-1";